import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";

// SKILL §3 progressive-loading: spinners give no shape preview.
// Skeleton bubbles approximate the actual chat layout so the reveal
// feels like content fading in instead of a layout swap.
const useStyles = makeStyles((theme) => ({
  wrap: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    padding: "20px 16px",
  },
  row: {
    display: "flex",
    width: "100%",
  },
  rowLeft: {
    justifyContent: theme.direction === "rtl" ? "flex-end" : "flex-start",
  },
  rowRight: {
    justifyContent: theme.direction === "rtl" ? "flex-start" : "flex-end",
  },
  bubble: {
    borderRadius: 12,
    padding: "8px 12px",
    minHeight: 38,
    maxWidth: "62%",
    backgroundColor:
      theme.palette.type === "dark"
        ? "rgba(255,255,255,0.06)"
        : "rgba(15, 23, 42, 0.05)",
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  bubbleOut: {
    backgroundColor:
      theme.palette.type === "dark"
        ? "rgba(99, 102, 241, 0.18)"
        : "rgba(99, 102, 241, 0.10)",
  },
}));

const Bubble = ({ side, lines }) => {
  const classes = useStyles();
  return (
    <div
      className={`${classes.row} ${
        side === "left" ? classes.rowLeft : classes.rowRight
      }`}
    >
      <div
        className={`${classes.bubble} ${
          side === "right" ? classes.bubbleOut : ""
        }`}
        style={{ width: lines.width }}
      >
        {lines.rows.map((w, i) => (
          <Skeleton
            key={i}
            animation="wave"
            height={10}
            width={w}
            style={{ borderRadius: 4 }}
          />
        ))}
      </div>
    </div>
  );
};

const MessagesListSkeleton = () => {
  const classes = useStyles();
  // Pattern alternates incoming/outgoing with varying widths so the
  // placeholder looks like a real conversation, not a list of bars.
  const pattern = [
    { side: "left", lines: { width: 200, rows: ["80%", "55%"] } },
    { side: "right", lines: { width: 240, rows: ["90%"] } },
    { side: "left", lines: { width: 160, rows: ["70%"] } },
    { side: "right", lines: { width: 280, rows: ["95%", "60%"] } },
    { side: "left", lines: { width: 220, rows: ["85%", "70%", "40%"] } },
    { side: "right", lines: { width: 150, rows: ["75%"] } },
  ];
  return (
    <div className={classes.wrap}>
      {pattern.map((p, i) => (
        <Bubble key={i} side={p.side} lines={p.lines} />
      ))}
    </div>
  );
};

export default MessagesListSkeleton;
